import { cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

export interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  hint?: string;
  /** A way out — "show all documents", "reset the filters". */
  action?: ReactNode;
  className?: string;
}

/**
 * The "nothing here" panel the prototype repeats under every list.
 *
 * It always offers an escape hatch, because in this console an empty list almost never
 * means an empty database — it means the filter chips are set to a status with no rows.
 * A dead end there reads as data loss.
 */
export function EmptyState({ icon: Icon, title, hint, action, className }: EmptyStateProps) {
  return (
    <div data-slot="empty-state" className={cn('py-16 text-center', className)}>
      <Icon aria-hidden className="mx-auto h-10 w-10 text-conc-200" strokeWidth={1.6} />
      <p className="mt-3 text-[14px] font-bold text-navy">{title}</p>
      {hint && <p className="mt-1 text-[12.5px] text-conc-500">{hint}</p>}
      {action && <div className="mt-3 flex justify-center">{action}</div>}
    </div>
  );
}
